import React from 'react';
import { useFormik } from 'formik';
import _ from 'lodash';
// import { useLocation } from 'react-router-dom'

// import { } from 'react-bootstrap';
// import styled from 'styled-components';
// import { up, down } from 'styled-breakpoints';

import { Spin } from "antd";

// Auth
// import { useAuthContext } from '../../../../auth/use-auth-context.js';
import { useRouter } from '../../../../auth/auth-guard.js';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector, Tables } from '../../../../utils/store.tsx';
import slice, { FormikContext, fields, initialValues, formSchema, prepareForm, prepareData, prepareDefaultLocations, isLastStepHasEmptyVehicle, stepsValidation, getId, isEdit } from './slice.tsx';

// enums
import { getBoolProps, updateRow, createRow, getMaxPageSize, danger, isNumeric } from '../../../../utils/utils.tsx';
import { Permissions } from '../../../../utils/enums.tsx';

// layouts
import ManageLayout from '../../../../layouts/manage/Layout.tsx';

// components
import MainContainer from '../../../../components/container/MainContainer.jsx';
import createGenericSlice, { BackOptions } from '../../../../components/table/withSlice/tableSlice.tsx';

import Tab1 from './form/Tab1.tsx';
import Tab2 from './form/Tab2.tsx';
import Tab3 from './form/Tab3.tsx';
import DefaultLocationForm from './form/defaultLocation/Form.tsx';

import { ReactComponent as ActiveTabIcon } from "../../../../../v5/assets/icons/active-tab.svg";
import { ReactComponent as InactiveTabIcon } from "../../../../../v5/assets/icons/inactive-tab.svg";
import { ReactComponent as PrevIcon } from "../../../../../v5/assets/icons/arrow-left.svg";
import { ReactComponent as NextIcon } from "../../../../../v5/assets/icons/arrow-right.svg";
import { ReactComponent as XIcon } from "../../../../../v5/assets/icons/smallX.svg";
import { ReactComponent as CheckIcon } from "../../../../../v5/assets/icons/check.svg";

// ----------------------------------------------------------------------

const table = createGenericSlice<any>(Tables.JobTypes);

const PageComponent = () => {
  // const location = useLocation();
  const router = useRouter();


  // const { user }: any = useAuthContext();
  // const { userAccount } = user ?? {};
  // const someField = userAccount?.someField;

  const formikRef = React.useRef<any>(null);

  const { tab, isLoading, isLoadingCreateUpdateDelete, details, defaultLocations, isLoadingDefaultLocations } = useTypedSelector((state: RootState) => state.manageJobTypesSlice);
  const { tableData, tableTotal } = useTypedSelector((state: RootState) => state.tableJobTypes);
  const dispatch = useDispatch<AppDispatch>();

  const [backLink, _setBackLink] = React.useState<any>('/v5/manage/job/job-types');
  const [permission, _setPermission] = React.useState<any>([Permissions.ManageJobs[0]]);
  const [validateOnChange, setValidateOnChange] = React.useState<boolean>(false);
  
  const [tabs, _setTabs] = React.useState<any>([
    {
      text: 'Job Type Info',
      eventKey: 'tab1',
      disabled: false,
    },
    {
      text: 'Job Steps',
      eventKey: 'tab2',
      disabled: false,
    },
    {
      text: 'Driver App Options',
      eventKey: 'tab3',
      disabled: false,
    },
  ]);


  React.useEffect(() => {
    onResetSlice();

    setTimeout(() => {
      dispatch(slice.setTab('tab1'));

      let id = getId();
      
      if(id && id > 0){
        dispatch(slice.callDetailsApi(id, (state: boolean, data: any) => {
          let params = {
            currentPage: 1,
            pageSize: getMaxPageSize(),
            sortColumn: 'locationName',
            sortDir: 'asc',
          };
          dispatch(slice.callReadDefaultLocationApi(params, (state: boolean, data: any) => {}));
        }));
  
      } else {
        let params = {
          currentPage: 1,
          pageSize: getMaxPageSize(),
          sortColumn: 'locationName',
          sortDir: 'asc',
        };
        dispatch(slice.callReadDefaultLocationApi(params, (state: boolean, data: any) => {}));
      }
    }, 0);
    
    return () => {
      onResetSlice();
    };
  }, []);

  React.useEffect(() => {
    dispatch(slice.setLoading(true));
    let form = prepareDefaultLocations(values, defaultLocations);
    setValues(form);
    dispatch(slice.setLoading(false));
  }, [defaultLocations]);

  React.useEffect(() => {
    dispatch(slice.setLoading(true));
    let form = prepareForm(details, initialValues);
    setValues(form);
    dispatch(slice.setLoading(false));
  }, [details]);

  React.useEffect(() => {
    setValidateOnChange((tab === 'tab2') ? true : false)
  }, [tab]);


  const formik = useFormik({
    initialValues: initialValues,
    validateOnMount: false,
    validateOnChange: validateOnChange,
    validationSchema: formSchema(null),
    onSubmit: values => {
      onSubmit(values, (data: any) => {});
    },
  });
  const { values, errors, setValues, setFieldValue, validateForm, handleSubmit }: any = formik;
  formikRef.current = formik;

  const onSubmit = (values: any, callback: (data: any) => void) => {
    let isCopy = getBoolProps();
    let data = prepareData(values, getId(), isCopy);
    let isEmpty = isLastStepHasEmptyVehicle(values.templateSteps);

    if(isEmpty){
      if(isEdit()){
        if(isCopy){
          dispatch(slice.callCreateApi(data, (state: boolean, data: any) => {
            if(state){
              let rows = createRow(tableData, 'jobTemplateId', { ...data, isNew: true });
              dispatch(table.callSetData({ data: rows, total: (tableTotal+1)}));
              onCancel(BackOptions.Create, data);
            }
          }));
        } else {
          dispatch(slice.callUpdateApi(data, (state: boolean, data: any) => {
            if(state){
              let rows = updateRow(tableData, 'jobTemplateId', { ...data, isNew: false });
              dispatch(table.callSetData({ data: rows, total: tableTotal}));
              onCancel(BackOptions.Update, data);
            }
          }));
        }
      } else {
        dispatch(slice.callCreateApi(data, (state: boolean, data: any) => {
          if(state){
            let rows = createRow(tableData, 'jobTemplateId', { ...data, isNew: true });
            dispatch(table.callSetData({ data: rows, total: (tableTotal+1)}));
            onCancel(BackOptions.Create, data);
          }
        }));
      }
    } else {
      danger('Vehicle status', 'The vehicle must be empty in the last step');
    }
  }
  const onResetSlice = () => {
    let form = prepareForm(null, initialValues);
    setValues(form);
    dispatch(slice.setValues(form));
    dispatch(slice.setTab('tab1'));
    dispatch(slice.resetSlice());
    }
  const onCancel = (backOptions: number = BackOptions.Read, data: any = null) => {
    onResetSlice();
    
    if(backOptions === BackOptions.Create){
      router.pushArgs(backLink, { backOptions: backOptions, backData: data });
    } else if(backOptions === BackOptions.Update){
      router.pushArgs(backLink, { backOptions: backOptions, backData: data });
    } else {
      router.push(backLink);
    }
  }


  const getTabIndex = (x: string) => {
    return tabs.findIndex((y: any) => y.eventKey === x);
  }
  const getTabItem = (x: string) => {
    return tabs.find((y: any) => y.eventKey === x);
  }
  const getPrevTab = () => {
    let index = getTabIndex(tab);
    
    if(tabs && tabs.length > 0){
      try {
        let item = tabs[index - 1];

        if(item){
          return item.eventKey;
        } else {
          return tab;
        }
      } catch(e){
        return tab;
      }
    } else {
      return tab;
    }
  }
  const getNextTab = () => {
    let index = getTabIndex(tab);
    
    if(tabs && tabs.length > 0){
      try {
        let item = tabs[index + 1];

        if(item){
          return item.eventKey;
        } else {
          return tab;
        }
      } catch(e){
        return tab;
      }
    } else {
      return tab;
    }
  }
  const getFirstTab = () => {
    if(tabs && tabs.length > 0){
      try {
        let item = tabs[0];

        if(item){
          return item.eventKey;
        } else {
          return tab;
        }
      } catch(e){
        return tab;
      }
    } else {
      return tab;
    }
  }
  const getLastTab = () => {
    if(tabs && tabs.length > 0){
      try {
        let item = tabs[tabs.length-1];

        if(item){
          return item.eventKey;
        } else {
          return tab;
        }
      } catch(e){
        return tab;
      }
    } else {
      return tab;
    }
  }
  const isCurrentTab = (x: string) => {
    try {
      let tabItem = getTabItem(x);

      if(tabItem){
        return (tabItem.eventKey === tab);
      } else {
        return false;
      }
    } catch(e){
      return false;
    }
  }
  const isValidTab = (x: string) => {
    let tabIndex = getTabIndex(x);
    let currentTabIndex = getTabIndex(tab);

    if(tabIndex < currentTabIndex){
      return 'valid';
    } else {
      return '';
    }
  }
  const isInvalidTab1 = (x: string) => {
    let cls = '';
    let invalidCls = 'invalid';
    let invalidCurrentCls = 'invalid-current';

    if(errors && errors.jobTemplateName){
      cls = invalidCurrentCls;
    } else {
      cls = '';
    }

    return cls;
  }
  const isInvalidTab2 = (x: string) => {
    let cls = '';
    let invalidCls = 'invalid';
    let invalidCurrentCls = 'invalid-current';

    if(errors && errors.templateSteps && errors.templateSteps.length > 0){
      cls = invalidCurrentCls;
    } else {
      cls = '';
    }

    return cls;
  }
  const isInvalidTab3 = (x: string) => {
    let cls = '';
    let invalidCls = 'invalid';
    let invalidCurrentCls = 'invalid-current';

    if(errors && errors.templateSteps && errors.templateSteps.length > 0){
      cls = '';
    } else {
      cls = '';
    }

    return cls;
  }
  const canNext = (eventKey: string, err: any) => {
    let canNext = true;
    
    if(eventKey === 'tab2'){
      canNext = (err && err.jobTemplateName) ? false : true;
    } else if(eventKey === 'tab3'){
      if(err && err.templateSteps){
        if(err.templateSteps.length > 0){
          canNext = false;
        } else {
          let validationObj = stepsValidation(values?.templateSteps);
          canNext = validationObj?.isValid;
        }
      }
    }

    return canNext;
  }

  const setContent = () => {
    let item = getTabItem(tab);

    if(item.eventKey === 'tab1'){
      return <Tab1 />
    } else if(item.eventKey === 'tab2'){
      return <Tab2 formikRef={formikRef} />
    } else if(item.eventKey === 'tab3'){
      return <Tab3 formikRef={formikRef} />
    } else {
      return <></>;
    }
  }


  return <MainContainer className={'p-0'} title={'Manage'} isLoading={false} roles={Permissions.ManageJobs}>
    <FormikContext.Provider value={formik}>
      <ManageLayout
        listName={(tab != 'tab1') ? values.jobTemplateName || ((getId() > 0) ? 'Update Job Type' : 'Create Job Type') : ((getId() > 0) ? 'Update Job Type' : 'Create Job Type')}
        backLink={onCancel}
        isList={false}

        permission={permission}
        pages={[]}

        buttons={[]}

        defaultTab={tab}
        tabs={tabs.map((x: any) => {
          return {
            eventKey: x.eventKey,
            disabled: x.disabled,
            text: () => {
              if(x.eventKey === 'tab1'){
                return <div className={isValidTab(x.eventKey) + ' ' + isInvalidTab1(x.eventKey)}>
                  {isCurrentTab(x.eventKey) ? <ActiveTabIcon /> : <InactiveTabIcon />}
                  <span className='ps-8'>{x.text}</span>
                </div>
              } else if(x.eventKey === 'tab2'){
                return <div className={isValidTab(x.eventKey) + ' ' + isInvalidTab2(x.eventKey)}>
                  {isCurrentTab(x.eventKey) ? <ActiveTabIcon /> : <InactiveTabIcon />}
                  <span className='ps-8'>{x.text}</span>
                </div>
              } else if(x.eventKey === 'tab3'){
                return <div className={isValidTab(x.eventKey) + ' ' + isInvalidTab3(x.eventKey)}>
                  {isCurrentTab(x.eventKey) ? <ActiveTabIcon /> : <InactiveTabIcon />}
                  <span className='ps-8'>{x.text}</span>
                </div>
              }
            },
            onClick: () => {
              validateForm().then((err: any) => {
                let canN = canNext(x.eventKey, err)
                if(canN){
                  dispatch(slice.setTab(x.eventKey));
                }
              })
            }
          }
        })}

        footerButtons={[
          {
            text: <>
              <XIcon /><span className='px-2'>Cancel</span>
            </>,
            variant: 'custom-outlined',
            invisible: (tab !== getFirstTab()),
            active: false,
            disabled: false,
            onClick: () => {
              onCancel();
            }
          },
          {
            text: <>
              <PrevIcon /><span className='px-2'>Prev</span>
            </>,
            variant: 'custom-outlined',
            invisible: (tab === getFirstTab()),
            active: false,
            disabled: false,
            onClick: () => {
              validateForm()

              let tab = getPrevTab();
              dispatch(slice.setTab(tab));
            }
          },
          {
            text: <>
              <span className='px-2'>Next</span><NextIcon />
            </>,
            variant: 'custom-primary',
            invisible: (tab === getLastTab()),
            active: false,
            disabled: !canNext(getNextTab(), errors),
            onClick: () => {
              validateForm().then((err: any) => {
                let tab = getNextTab();

                let canN = canNext(tab, err)
                if(canN){
                  dispatch(slice.setTab(tab));
                }
              })
            }
          },
          {
            text: <>
              <CheckIcon /><span className='px-2'>Done</span>
            </>,
            variant: 'custom-primary',
            invisible: (tab !== getLastTab()),
            active: false,
            disabled: (isLoadingCreateUpdateDelete || (Object.entries(errors).length > 0)),
            onClick: () => {
              handleSubmit()
            }
          },
        ]}
      >
        <Spin spinning={isLoading || isLoadingDefaultLocations} wrapperClassName={'no-height'}>{setContent()}</Spin>
      </ManageLayout>
    </FormikContext.Provider>

    <DefaultLocationForm
      onCreate={(index: any, data: any) => {
        // if(isNumeric(index) && values?.templateSteps?.[index]?.defaultLocationId === null){
          setFieldValue('templateSteps.' + index + '.defaultLocationId', data?.defaultLocationId);
          setFieldValue('templateSteps.' + index + '.defaultLocation', data);
        // }
      }}
      onUpdate={(index: any, data: any) => {
        if(isNumeric(index) && (values?.templateSteps?.[index]?.defaultLocationId == data?.defaultLocationId)){
          let items = _.cloneDeep(values.templateSteps);
          if(items && items.length > 0){
            items.forEach((itm: any) => {
              if(itm.defaultLocationId == data?.defaultLocationId){
                itm.defaultLocation = data;
              }
            });
          }
          setFieldValue('templateSteps', items);
        }
      }}
      onDelete={(index: any, id: any) => {
        if(isNumeric(index) && (values?.templateSteps?.[index]?.defaultLocationId == id)){
          let items = _.cloneDeep(values.templateSteps);
          if(items && items.length > 0){
            items.forEach((itm: any) => {
              if(itm.defaultLocationId == id){
                itm.defaultLocationId = null;
                itm.defaultLocation = null;
              }
            });
          }
          setFieldValue('templateSteps', items);
        }
      }}
    />
  </MainContainer>
}

export default PageComponent;
